import * as Element from '../element/main';

interface Data {
  label       : string;
  maxLength   : string;
  value       : string;
  placeholder : string;
  helpText    : string;
  lang        : string;
  errorMsg   ?: string;
}
interface Dataset extends Data, DOMStringMap {}

interface Input extends Data{
  parent      : HTMLElement,
  id          : string, 
}

export interface Elm extends HTMLDivElement {
  dataset: Dataset;
  xDelete  : () => void;
  xIsValid : () => boolean;
  xWeight  : (weight: number) => void;
  xSet     : (value: number) => void;
}


/**
 * Returns the base tag
 */
export function add(data: Input): Elm {

  const elm = 
    !!document.getElementById(data.id) ? document.getElementById(data.id) as Elm : 
    /*else*/                             document.createElement('div')    as Elm;
  
  Object.assign(elm.dataset, data);
  
  data.parent.appendChild(elm);
  elm.id = data.id;
  init(elm);
  
  return elm;
}




export function init(elm: Elm) {

  updateWidget(elm);


  // Delete method
  elm.xDelete = () => {

    const dataElm = document.getElementById(`${elm.id}__url`) as HTMLInputElement;
    dataElm.value = '';
    elm.dataset.errorMsg = '';

    // Send event for form tabs.
    const event = new CustomEvent('noError', {bubbles: true});
    elm.dispatchEvent(event);
  }

  // Validation method
  elm.xIsValid = () => {
    validate(elm);
    updateWidget(elm);
    return !(elm.dataset.errorMsg);
  }


  // Changed text
  elm.addEventListener('focusout', event => {

    // Exit if wrong element
    const target = event.target as HTMLElement;
    if (target.id != `${elm.id}__data` ) return;

    const dataElm = document.getElementById(`${elm.id}__data`) as HTMLInputElement;

    elm.dataset.value = dataElm.value;
    
    validate(elm);
    updateWidget(elm);
  });

  // Helper button
  elm.addEventListener('click', event => {
    const target = event.target as HTMLElement;
    if (target.id != `${elm.id}__help-button`) return;

    const helpText = document.getElementById(`${elm.id}__help-text`);
    helpText.classList.toggle('hidden');
  });


  
}

export function validate(elm: Elm) {

  const de = document.documentElement.lang == 'de';
  const isEmail  = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const errorFormat = de ? 
    'Ungültiges E-Mail-Format':
    'Invalid email format';
  
  const errorMandatory = de ?
    'Das Feld muss ausgefüllt werden':
    'The field must not be empty';

  const isValidFormat =
    elm.dataset.value.length == 0 ||
    isEmail.test(elm.dataset.value);
  
  const isValidMandatory = 
    elm.dataset.mandatory == '1' && !!elm.dataset.value ? true : 
    elm.dataset.mandatory == '0'                        ? true :
    !elm.dataset.mandatory                              ? true :
    /*else*/                                              false;
  
  const isValid = 
    isValidFormat && isValidMandatory;

  const errorMsg =
    !isValidMandatory ? errorMandatory : 
    !isValidFormat    ? errorFormat    :
    /*else*/ '';

  if (isValid) {
    elm.dataset.errorMsg = '';
    const event = new CustomEvent('noError', {bubbles: true});
    elm.dispatchEvent(event);
  }
  else {
    elm.dataset.errorMsg = errorMsg;
    const event = new CustomEvent('hasError', {bubbles: true});
    elm.dispatchEvent(event);
  }

  return isValid;
}



function updateWidget(elm: Elm) {

  elm.classList.add('widget');
  elm.classList.add('email-widget');
  if (elm.dataset.lang) elm.classList.add(elm.dataset.lang);


  const label = Element.label({
    parent      : elm,
    id          : `${elm.id}__label`,
    htmlFor     : elm.id,
    innerHTML   : elm.dataset.label,
  });
  const input = Element.input({
    parent      : elm,
    id          : `${elm.id}__data`,
    type        : 'text',
    className   : elm.dataset.helpText ? 'help' : '',
    name        : elm.id,
    value       : elm.dataset.value,
    placeholder : elm.dataset.placeholder,
    maxLength   : elm.dataset.maxLength,
  });
  const helpButton = Element.button({
    parent      : elm,
    id          : `${elm.id}__help-button`,
    className   : `help ${elm.dataset.helpText ? '' : 'hidden'}`,
    type        : 'button',
    innerHTML   : '?',
  });
  const ErrorText = Element.div({
    parent      : elm,
    id          : `${elm.id}__error`,
    className   : `field-error ${elm.dataset.errorMsg ? 'has-errors' : ''}`,
    innerHTML   : elm.dataset.errorMsg,
  });
  const helpText = Element.div({
    parent      : elm,
    id          : `${elm.id}__help-text`,
    className   : 'help-block hidden',
    innerHTML   : elm.dataset.helpText,
  });
}